/**
 * 花のパッセージ B2B ECサイト カスタムスクリプト
 * 業者向け会員制ECサイト用JavaScript
 */

/* ============================================================
   パスワード表示切替
   ============================================================ */
function togglePassword(inputId) {
  const input = document.getElementById(inputId);
  const button = input.nextElementSibling;
  if (input.type === 'password') {
    input.type = 'text';
    button.textContent = '非表示';
  } else {
    input.type = 'password';
    button.textContent = '表示';
  }
}

/* ============================================================
   登録フォームのバリデーション強化
   ============================================================ */
document.addEventListener('DOMContentLoaded', function () {

  const registerForm = document.getElementById('create_customer');
  if (registerForm) {
    registerForm.addEventListener('submit', function (e) {
      const businessType = document.getElementById('business_type');
      const consent = document.getElementById('consent');

      if (businessType && !businessType.value) {
        e.preventDefault();
        businessType.focus();
        showError(businessType, '業種を選択してください');
        return;
      }

      if (consent && !consent.checked) {
        e.preventDefault();
        consent.focus();
        alert('プライバシーポリシーおよび利用規約への同意が必要です。');
        return;
      }
    });
  }

  /* --- フィールドのリアルタイムバリデーション --- */
  const emailField = document.getElementById('email') || document.getElementById('customer_email');
  if (emailField) {
    emailField.addEventListener('blur', function () {
      const val = this.value.trim();
      if (val && !isValidEmail(val)) {
        showError(this, '正しいメールアドレスを入力してください');
      } else {
        clearError(this);
      }
    });
  }

  const passwordField = document.getElementById('password');
  if (passwordField) {
    passwordField.addEventListener('blur', function () {
      if (this.value.length > 0 && this.value.length < 8) {
        showError(this, 'パスワードは8文字以上で設定してください');
      } else {
        clearError(this);
      }
    });
  }

});

function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function showError(element, message) {
  clearError(element);
  const errorEl = document.createElement('p');
  errorEl.className = 'field-error';
  errorEl.style.cssText = 'color:#c0392b;font-size:12px;margin-top:4px;';
  errorEl.textContent = message;
  element.parentNode.appendChild(errorEl);
  element.style.borderColor = '#c0392b';
}

function clearError(element) {
  const parent = element.parentNode;
  const existing = parent.querySelector('.field-error');
  if (existing) existing.remove();
  element.style.borderColor = '';
}

/* ============================================================
   非会員ユーザーへの価格ぼかし処理
   商品一覧ページで価格を隠す
   ============================================================ */
(function initMemberGate() {
  // Shopifyのliquidで {{ customer }} が null のとき data-guest="true" を付与する想定
  const isGuest = document.body.dataset.guest === 'true';
  if (!isGuest) return;

  // 価格要素をぼかす
  document.querySelectorAll('.price, .product__price, [class*="price"]').forEach(function (el) {
    el.style.filter = 'blur(4px)';
    el.style.userSelect = 'none';
    el.title = '会員登録が必要です';
  });

  // カートボタンを無効化
  document.querySelectorAll('[data-type="add-to-cart"], .product-form__submit').forEach(function (btn) {
    btn.disabled = true;
    btn.textContent = '会員限定 – ログインして購入';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      window.location.href = '/account/login';
    });
  });
})();

/* ============================================================
   スクロールアニメーション
   ============================================================ */
(function initScrollAnimation() {
  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'none';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.category-card, .category-group, .form-section').forEach(function (el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(16px)';
    el.style.transition = 'opacity .4s ease, transform .4s ease';
    observer.observe(el);
  });
})();
